define('viewmodels/HeatMaps/CRAResidualsRiskHeatMap',['knockout', 'plugins/router', 'services/navigation', 'services/logger', 'durandal/system', 'services/appsecurity', 'durandal/app', 'services/GeoHeatMap', 'services/utils', 'viewmodels/GeneralSettings'],
    function (ko, router, navigation, logger, system, appsecurity, app, GeoHeatMap, utils, ObjGeneralSettings) {
        var title = 'Heat Map';

        var HmViewModel = {
            activate: activate,
            detached: detached,
            attached: attached,
            title: title,
            utils: utils,
            appsecurity: appsecurity,
            openSideNav: openSideNav,
            closeSideNav: closeSideNav,
            CollapseAll: CollapseAll,
            ExpandAll: ExpandAll,
            colExpand: ko.observable(false),
            ObjGeneralSettings: ObjGeneralSettings,
            BUTitle: ko.observable('Business Unit'),
            IsSideNavOpen: ko.observable(0),
            resetInRiskTheme: ko.observableArray(),
            AssessmentType: ko.observable(""),
            ResHeatMapData: ko.observableArray(),
            ResHeatMapDataDUP: ko.observableArray(),
            OverrideCommentsList: ko.observableArray(),
            BusinessLevelList: ko.observableArray(),
            ClickedBusinessLevelId: ko.observable(),
            ClickedBusinessLevelName: ko.observable(),
            BusinessLevelTabClick: BusinessLevelTabClick,
            NavigateToSSRSExportReport: NavigateToSSRSExportReport,
            SourceName: ko.observable("RES"),
            AssessmentTypeId: ko.observable(),
            BusinessLevel: ko.observable(),
            ScreenName: ko.observable(),
            ResRiskThemeDetails: ko.observableArray([]),
            ResRiskThemeDetailsDUP: ko.observableArray([]),
            AggregateBUDetails: ko.observableArray([]),
            AggregateBUDetailsDUP: ko.observableArray([]),
            riskType: ko.observable(''),
            InhRiskThemeDetails: ko.observableArray([]),
            InhRiskThemeDetailsSearch: ko.observableArray([]),
            ContRiskThemeDetails: ko.observableArray([]),
            categories: ko.observableArray([]),
            //filter feature
            NumberOfBUsSelected: ko.observable(),
            ShowAllData: ko.observable(true),
          
            SelectedBUs: ko.observable(),
            ApplyBuFilters: ApplyBuFilters,
            HeatmapDatadup: ko.observable(),
            FinalOrgFilterList: ko.observableArray([]),
            ClearAllBuFilters: ClearAllBuFilters,
            BusinessUnitListForFilters: ko.observableArray([]),
            BusinessUnitListForFiltersDUP: ko.observableArray([]),
            InitialBusinessUnitListForFilters: ko.observableArray([]),
            BUFiltersApplied: ko.observable(false),
            OrgLvlDrpDwnList: ko.observableArray(),
            OrgLvlValueList: ko.observableArray(),
            SelectedCheckedList: ko.observableArray([]),
            SelectedCheckedBUList: ko.observableArray([]),
            SubCheckboxSelected: SubCheckboxSelected,
            BusinessUnitListDUP: ko.observableArray([]),
            BusinessUnitList: ko.observableArray([]),
            ClickedRiskAreaType: ko.observable(),
            ClearOrgFilterSelection: ClearOrgFilterSelection,
            DistinctFileredBUs: ko.observableArray([]),
            ClearBUFilterSelection: ClearBUFilterSelection,
            ComposeBindingFlag: ko.observable(false),
            SubFactorGridDataList: ko.observableArray([]),
            TaxonomyLevelList: ko.observableArray([]),
            DataTableColumnWidth: ko.observable('&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;'),
            DisplayExportDropdown: DisplayExportDropdown,
            ColspanValue: ko.observable(1),
            editableTypes: ko.observableArray([]),
            CRAAggregateBUInformation: ko.observableArray([]),
            ShowFinalData: ko.observable(false),
            ClickShowComments: ClickShowComments,
            FormatValueDataLevel: FormatValueDataLevel,
            valuechangeLevel: valuechangeLevel,
           
            expandCollapseColumns: ko.observableArray([]),
            expand: expand,
            collapse: collapse,
            state: ko.observable(true),
            Expandcollapse: ko.observable(0),
            level: ko.observable(3),
            clickLevel: clickLevel,
            ResetSearch: ResetSearch,
            SearchResult: SearchResult,
            Query: ko.observable(''),
            ClearResult: ClearResult,
            InherentFilter: InherentFilter,
            ControlFilter: ControlFilter,
            ResidualFilter: ResidualFilter,
            FilterALL: FilterALL,
            Multilist: ko.observableArray([]),
            RAT_Config_Type: ko.observable(2),
            AMLContMultilist: ko.observableArray([]),
            //AML
            AggregateBUDetailsInherent: ko.observableArray([]),
            AggregateBUDetailsControl: ko.observableArray([]),
            AggregateBUDetailsResidual: ko.observableArray([]),

            expandInherent: expandInherent,
            showInherent: ko.observable(true),
            Inhstate: ko.observable(true),
            Cntstate: ko.observable(true),
            expandControl: expandControl,
            showControl: ko.observable(true),
            expandResidual: expandResidual,
            Resstate: ko.observable(true),
            showResidual: ko.observable(true),
        };

        return HmViewModel;

        function activate() {
            try {
                
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: activate() method in CRAResidualRiskHeatMap.js';
                logger.logMessage(msg);
            }
        }

       
        function collapse(Id) {
            try {
                $("#ICexapnd" + Id).hide()
                $("#ICcollapse" + Id).show()

                if ($("#colspan_" + Id) != undefined && $("#colspan_" + Id)[0] != undefined)
                    $("#colspan_" + Id)[0].colSpan = 1;

                for (var i = 0; i < HmViewModel.editableTypes().length - 1; i++) {
                    $("#Bu" + Id + "_" + HmViewModel.editableTypes()[i].ResponseId()).hide();
                }

                for (var i = 0; i < HmViewModel.InhRiskThemeDetails().length; i++) {
                    var counter = 0;
                    for (var j = 0; j < HmViewModel.InhRiskThemeDetails()[i].BusinessUnitCountList.length; j++) {
                        for (var k = 0; k < HmViewModel.InhRiskThemeDetails()[i].BusinessUnitCountList[j].ResponseList.length - 1; k++) {
                            if (Id == HmViewModel.InhRiskThemeDetails()[i].BusinessUnitCountList[j].ResponseList[k].BU_ID) {
                                counter++;
                                var cellData = HmViewModel.InhRiskThemeDetails()[i].BusinessUnitCountList[j].ResponseList[k];
                                $('#Bu' + Id + '-' + cellData.Id + '-' + cellData.ZAT_UID).hide();
                            }
                        }
                        if (counter > 0)
                            break;
                    }
                }
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ClearOrgFilterSelection() method in ResidualRiskHeatMap.js';
                logger.logMessage(msg);
            }

        }

        function expand(Id) {
            try {
                
                $("#ICcollapse" + Id).hide();
                $("#ICexapnd" + Id).show();

                if ($("#colspan_" + Id) != undefined && $("#colspan_" + Id)[0] != undefined)
                    $("#colspan_" + Id)[0].colSpan = HmViewModel.editableTypes().length;

                for (var i = 0; i < HmViewModel.editableTypes().length - 1; i++) {
                    $("#Bu" + Id + "_" + HmViewModel.editableTypes()[i].ResponseId()).show();
                }

                for (var i = 0; i < HmViewModel.InhRiskThemeDetails().length; i++) {
                    var counter = 0;
                    for (var j = 0; j < HmViewModel.InhRiskThemeDetails()[i].BusinessUnitCountList.length; j++) {

                        for (var k = 0; k < HmViewModel.InhRiskThemeDetails()[i].BusinessUnitCountList[j].ResponseList.length - 1; k++) {
                            if (Id == HmViewModel.InhRiskThemeDetails()[i].BusinessUnitCountList[j].ResponseList[k].BU_ID) {
                                counter++;
                                var cellData = HmViewModel.InhRiskThemeDetails()[i].BusinessUnitCountList[j].ResponseList[k];
                                $('#Bu' + Id + '-' + cellData.Id + '-' + cellData.ZAT_UID).show();
                            }
                        }
                        if (counter > 0)
                            break;

                    }
                }
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: collapse() method in ResidualRiskHeatMap.js';
                logger.logMessage(msg);
            }

        }


        function CollapseAll() {
            try {
                for (var i = 0; i < HmViewModel.InhRiskThemeDetails().length; i++) {
                    var d = HmViewModel.InhRiskThemeDetails()[i];

                    if (d.LevelState) {
                        d.LevelState = false;
                    }

                    if (d.PId != 0) {
                        $(".taxo_" + d.Id).hide();
                        $('#spandown' + d.Id).hide();
                        $('#spanright' + d.Id).show();
                    } else {
                        $('#spandown' + d.Id).hide();
                        $('#spanright' + d.Id).show();
                    }
                }
                $('#expandA').show();
                $('#collapseA').hide();

                if (HmViewModel.RAT_Config_Type() != 2) {
                    HmViewModel.showInherent(false);
                    HmViewModel.Inhstate(false);
                    $("#spanInh").addClass("fa-caret-right").removeClass("fa-caret-down");

                    HmViewModel.showControl(false);
                    HmViewModel.Cntstate(false);
                    $("#spanCnh").addClass("fa-caret-right").removeClass("fa-caret-down");

                    HmViewModel.showResidual(false);
                    HmViewModel.Resstate(false);
                    $("#spanRes").addClass("fa-caret-right").removeClass("fa-caret-down");
                }

            } catch (e) {
                var msg = 'Exception: ' + e + ' | Source: CpllapseAll() method in ResidualRiskHeatMap.js';
                logger.logMessage(msg);
            }
        }

        function ExpandAll() {
            try {
                for (var i = 0; i < HmViewModel.InhRiskThemeDetails().length; i++) {
                    var d = HmViewModel.InhRiskThemeDetails()[i];
                    if (!d.LevelState) {
                        d.LevelState = true;
                    }

                    $(".taxo_" + d.Id).show();
                    $('#spandown' + d.Id).show();
                    $('#spanright' + d.Id).hide();
                }
                $('#expandA').hide();
                $('#collapseA').show();

                if (HmViewModel.RAT_Config_Type() != 2) {
                    HmViewModel.showInherent(true);
                    HmViewModel.Inhstate(true);
                    $("#spanInh").addClass("fa-caret-down").removeClass("fa-caret-right");

                    HmViewModel.showControl(true);
                    HmViewModel.Cntstate(true);
                    $("#spanCnh").addClass("fa-caret-down").removeClass("fa-caret-right");

                    HmViewModel.showResidual(true);
                    HmViewModel.Resstate(true);
                    $("#spanRes").addClass("fa-caret-down").removeClass("fa-caret-right");
                }
            } catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ExpandAll() method in ResidualRiskHeatMap.js';
                logger.logMessage(msg);
            }
        }


        function ClearOrgFilterSelection(data, event) {
            try {

                var selectedSubOrgLevelID = event.currentTarget.id.substr(event.currentTarget.id.indexOf("_") + 1);

                document.getElementById('DynamicOptedFilters_' + selectedSubOrgLevelID).innerHTML = "";

                $('.fa-check.' + selectedSubOrgLevelID).css({ 'display': 'none' });
                if (HmViewModel.SelectedCheckedList().length > 0) {
                    HmViewModel.SelectedCheckedList.remove(function (item) { return item.SubLevelId == selectedSubOrgLevelID });
                }

                //Logic to re-set the BU list
                HmViewModel.BusinessUnitListForFilters([]);
                if (HmViewModel.SelectedCheckedList().length > 0) {
                    var mappedBuList = $.map(HmViewModel.BusinessUnitListForFiltersDUP(), function (result) {
                        for (var m = 0; m < HmViewModel.SelectedCheckedList().length; m++) {
                            if (result.SubLevelId() == HmViewModel.SelectedCheckedList()[m].SubLevelId)
                                return new BusinessUnitModelDUP(result);
                        }
                    });
                    HmViewModel.BusinessUnitListForFilters(mappedBuList);
                    //Main tain this list to retain the org filters on deselection of applicability filters
                    HmViewModel.FinalOrgFilterList(mappedBuList);

                }
                else {
                    HmViewModel.BusinessUnitListForFilters([]);
                    var mappedBuList = $.map(HmViewModel.BusinessUnitListForFiltersDUP(), function (result) {
                        return new BusinessUnitModelDUP(result);
                    });
                    HmViewModel.BusinessUnitListForFilters(mappedBuList);
                    HmViewModel.FinalOrgFilterList(mappedBuList);
                    $('#BUFilterError').hide();
                }
                //Set count of BU's selected
                if (HmViewModel.BusinessUnitListForFilters().length > 0) {
                    HmViewModel.DistinctFileredBUs = ko.dependentObservable(function () {
                        var seen = [];
                        return HmViewModel.BusinessUnitListForFilters().filter(function (n) {
                            return seen.indexOf(n.BusinessUnitId()) == -1 && seen.push(n.BusinessUnitId());
                        });
                    });
                    HmViewModel.BusinessUnitListForFilters(HmViewModel.DistinctFileredBUs());
                }
              HmViewModel.NumberOfBUsSelected(HmViewModel.BusinessUnitListForFilters().length);
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ClearOrgFilterSelection() method in ResidualRiskHeatMap.js';
                logger.logMessage(msg);
            }
        }
        function ResetSearch() {
            try {
                HmViewModel.Query('');
                if (HmViewModel.InhRiskThemeDetails() != undefined) {
                    for (var i = 0; i < HmViewModel.InhRiskThemeDetails().length; i++) {
                        $(".taxo_" + HmViewModel.InhRiskThemeDetails()[i].Id).show();
                        $('#spandown' + HmViewModel.InhRiskThemeDetails()[i].Id).show();
                        $('#spanright' + HmViewModel.InhRiskThemeDetails()[i].Id).hide();
                    }
                }
                if (HmViewModel.ContRiskThemeDetails() != undefined) {
                    for (var j = 0; j < HmViewModel.ContRiskThemeDetails().length; j++) {
                        $(".taxo_" + HmViewModel.ContRiskThemeDetails()[j].Id).show();
                        $('#spandown' + HmViewModel.ContRiskThemeDetails()[j].Id).show();
                        $('#spanright' + HmViewModel.ContRiskThemeDetails()[j].Id).hide();
                    }
                }
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ResetSearch() method in ResidualRiskHeatMap.js';
                logger.logMessage(msg);
            }
        }

        function SearchResult() {
            try {

                if (HmViewModel.RAT_Config_Type() != 2) {
                    SearchResultAML();
                } else {
                    if (HmViewModel.InhRiskThemeDetails() != undefined && HmViewModel.InhRiskThemeDetails().length > 0) {
                        var searchedList = '';
                        var q = HmViewModel.Query();

                        searchedList = ko.utils.arrayFilter(HmViewModel.InhRiskThemeDetails(), function (item) {
                            if (q != "") {
                                if (item.Name.toLowerCase().indexOf(q.toLowerCase()) >= 0) {
                                    return item.Name.toLowerCase().indexOf(q.toLowerCase()) >= 0;
                                }
                            }
                        });

                        for (var i = 0; i < HmViewModel.InhRiskThemeDetails().length; i++) {
                            $(".taxo_" + HmViewModel.InhRiskThemeDetails()[i].Id).hide();
                        }

                        if (HmViewModel.Query() != undefined && HmViewModel.Query() == "") {
                            //for empty keyboard input
                            for (var i = 0; i < HmViewModel.InhRiskThemeDetails().length; i++) {
                                $(".taxo_" + HmViewModel.InhRiskThemeDetails()[i].Id).show();
                                $('#spandown' + HmViewModel.InhRiskThemeDetails()[i].Id).show();
                                $('#spanright' + HmViewModel.InhRiskThemeDetails()[i].Id).hide();
                            }
                        }
                        if (searchedList != undefined) {
                            for (var j = 0; j < searchedList.length; j++) {
                                for (var i = 0; i < HmViewModel.InhRiskThemeDetails().length; i++) {
                                    if (HmViewModel.InhRiskThemeDetails()[i].Id == searchedList[j].Id) {

                                        $(".taxo_" + HmViewModel.InhRiskThemeDetails()[i].Id).show();
                                        $('#spandown' + HmViewModel.InhRiskThemeDetails()[i].Id).show();
                                        $('#spanright' + HmViewModel.InhRiskThemeDetails()[i].Id).hide();
                                    }
                                }
                            }
                        }
                        for (var i = 0; i < searchedList.length; i++) {
                            if (searchedList[i].LevelId < searchedList[i].MaxLevel) {
                                ko.utils.arrayFilter(HmViewModel.InhRiskThemeDetails(), function (param) {
                                    if (param.PId === searchedList[i].Id) {
                                        $(".taxo_" + param.Id).show();
                                        $('#spandown' + param.Id).show();
                                        $('#spanright' + param.Id).hide();
                                        IterateSearch(param.Id);
                                        //return true;
                                    }
                                });
                            }// < then max level
                        }
                    }
                }
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: SearchResult() method in ResidualRiskHeatmap.js';
                logger.logMessage(msg);
            }
        }
        function IterateSearch(childId) {
            try {
                if (HmViewModel.InhRiskThemeDetails() != undefined && HmViewModel.InhRiskThemeDetails().length > 0) {
                    ko.utils.arrayFilter(HmViewModel.InhRiskThemeDetails(), function (param) {
                        if (param.PId === childId) {
                            IterateSearch(param.Id);
                            $(".taxo_" + param.Id).show();
                            $('#spandown' + param.Id).show();
                            $('#spanright' + param.Id).hide();
                            //return true;
                        }
                    });
                }
                if (HmViewModel.ContRiskThemeDetails() != undefined && HmViewModel.ContRiskThemeDetails().length > 0) {

                    ko.utils.arrayFilter(HmViewModel.ContRiskThemeDetails(), function (param) {
                        if (param.PId === childId) {
                            IterateSearch(param.Id);
                            $(".taxo_" + param.Id).show();
                            $('#spandown' + param.Id).show();
                            $('#spanright' + param.Id).hide();
                        }
                    });
                }
            } catch (e) {
                var msg = 'Exception: ' + e + ' | Source: SearchResult() method in SurveyResponsePage.js';
                logger.logMessage(msg);
            }
        }
        function AMLChildrenVisible(List, flag) {
            try {
                for (var i = 0; i < List.length; i++) {
                    if (flag) {
                        $(".taxo_" + List[i].Id).show();
                        $('#spandown' + List[i].Id).show();
                        $('#spanright' + List[i].Id).hide();
                    } else {
                        $(".taxo_" + List[i].Id).hide();
                        $('#spanright' + List[i].Id).show();
                        $('#spandown' + List[i].Id).hide();
                    }
                    if (List[i].childHeatMapData != undefined && List[i].childHeatMapData.length > 0) {
                        AMLChildrenVisible(List[i].childHeatMapData, flag);
                    }
                }
            } catch (e) {
                var msg = 'Exception: ' + e + ' | Source: AMLChildrenVisible() method in ResidualHeatmap.js';
                logger.logMessage(msg);
            }

        }

       
        function SearchResultAML() {
            try {
                //inherent
                if (HmViewModel.InhRiskThemeDetails() != undefined && HmViewModel.InhRiskThemeDetails().length > 0) {
                    var searchedList = '';
                    var q = HmViewModel.Query();

                    searchedList = ko.utils.arrayFilter(HmViewModel.InhRiskThemeDetails(), function (item) {
                        if (q != "") {
                            if (item.Name.toLowerCase().indexOf(q.toLowerCase()) >= 0) {
                                return item.Name.toLowerCase().indexOf(q.toLowerCase()) >= 0;
                            }
                        }
                    });

                    for (var i = 0; i < HmViewModel.Multilist().length; i++) {
                        $(".taxo_" + HmViewModel.Multilist()[i].Id).hide();
                        $('#spandown' + HmViewModel.Multilist()[i].Id).hide();
                        $('#spanright' + HmViewModel.Multilist()[i].Id).show();
                        if (HmViewModel.Multilist()[i].childHeatMapData != undefined && HmViewModel.Multilist()[i].childHeatMapData.length > 0) {
                            AMLChildrenVisible(HmViewModel.Multilist()[i].childHeatMapData, false);
                        }
                    }

                    if (HmViewModel.Query() != undefined && HmViewModel.Query() == "") {
                        //for empty keyboard input
                        for (var i = 0; i < HmViewModel.Multilist().length; i++) {
                            $(".taxo_" + HmViewModel.Multilist()[i].Id).show();
                            $('#spanright' + HmViewModel.Multilist()[i].Id).hide();
                            $('#spandown' + HmViewModel.Multilist()[i].Id).show();
                            if (HmViewModel.Multilist()[i].childHeatMapData != undefined && HmViewModel.Multilist()[i].childHeatMapData.length > 0) {
                                AMLChildrenVisible(HmViewModel.Multilist()[i].childHeatMapData, true);
                            }
                        }
                    }
                    if (searchedList != undefined) {
                        for (var j = 0; j < searchedList.length; j++) {
                            for (var i = 0; i < HmViewModel.InhRiskThemeDetails().length; i++) {
                                if (HmViewModel.InhRiskThemeDetails()[i].Id == searchedList[j].Id) {

                                    $(".taxo_" + HmViewModel.InhRiskThemeDetails()[i].Id).show();
                                    $('#spandown' + HmViewModel.InhRiskThemeDetails()[i].Id).show();
                                    $('#spanright' + HmViewModel.InhRiskThemeDetails()[i].Id).hide();
                                }
                            }
                        }
                    }
                    for (var i = 0; i < searchedList.length; i++) {
                        if (searchedList[i].LevelId < searchedList[i].MaxLevel) {
                            ko.utils.arrayFilter(HmViewModel.InhRiskThemeDetails(), function (param) {
                                if (param.PId === searchedList[i].Id) {
                                    $(".taxo_" + param.Id).show();
                                    $('#spandown' + param.Id).show();
                                    $('#spanright' + param.Id).hide();
                                    IterateSearch(param.Id);
                                }
                            });
                        }// < then max level
                    }
                }

                //controls
                if (HmViewModel.ContRiskThemeDetails() != undefined && HmViewModel.ContRiskThemeDetails().length > 0) {
                    var searchedList = '';
                    var q = HmViewModel.Query();

                    searchedList = ko.utils.arrayFilter(HmViewModel.ContRiskThemeDetails(), function (item) {
                        if (q != "") {
                            if (item.Name.toLowerCase().indexOf(q.toLowerCase()) >= 0) {
                                return item.Name.toLowerCase().indexOf(q.toLowerCase()) >= 0;
                            }
                        }
                    });


                    for (var i = 0; i < HmViewModel.AMLContMultilist().length; i++) {
                        $(".taxo_" + HmViewModel.AMLContMultilist()[i].Id).hide();
                        $('#spandown' + HmViewModel.AMLContMultilist()[i].Id).hide();
                        $('#spanright' + HmViewModel.AMLContMultilist()[i].Id).show();
                        if (HmViewModel.AMLContMultilist()[i].childHeatMapData != undefined && HmViewModel.AMLContMultilist()[i].childHeatMapData.length > 0) {
                            AMLChildrenVisible(HmViewModel.AMLContMultilist()[i].childHeatMapData, false);
                        }
                    }

                    if (HmViewModel.Query() != undefined && HmViewModel.Query() == "") {
                        //for empty keyboard input
                        for (var i = 0; i < HmViewModel.AMLContMultilist().length; i++) {
                            $(".taxo_" + HmViewModel.AMLContMultilist()[i].Id).show();
                            $('#spanright' + HmViewModel.AMLContMultilist()[i].Id).hide();
                            $('#spandown' + HmViewModel.AMLContMultilist()[i].Id).show();
                            if (HmViewModel.AMLContMultilist()[i].childHeatMapData != undefined && HmViewModel.AMLContMultilist()[i].childHeatMapData.length > 0) {
                                AMLChildrenVisible(HmViewModel.AMLContMultilist()[i].childHeatMapData, true);
                            }
                        }
                    }
                    if (searchedList != undefined) {
                        for (var j = 0; j < searchedList.length; j++) {
                            for (var i = 0; i < HmViewModel.ContRiskThemeDetails().length; i++) {
                                if (HmViewModel.ContRiskThemeDetails()[i].Id == searchedList[j].Id) {

                                    $(".taxo_" + HmViewModel.ContRiskThemeDetails()[i].Id).show();
                                    $('#spandown' + HmViewModel.ContRiskThemeDetails()[i].Id).show();
                                    $('#spanright' + HmViewModel.ContRiskThemeDetails()[i].Id).hide();
                                }
                            }
                        }
                    }
                    for (var i = 0; i < searchedList.length; i++) {
                        if (searchedList[i].LevelId < searchedList[i].MaxLevel) {
                            ko.utils.arrayFilter(HmViewModel.ContRiskThemeDetails(), function (param) {
                                if (param.PId === searchedList[i].Id) {
                                    $(".taxo_" + param.Id).show();
                                    $('#spandown' + param.Id).show();
                                    $('#spanright' + param.Id).hide();
                                    IterateSearch(param.Id);
                                    //return true;
                                }
                            });
                        }// < then max level
                    }
                }
                
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: SearchResult() method in SurveyResponsePage.js';
                logger.logMessage(msg);
            }
        }


        function closeSideNav() {
            try {
                $('#BusinessUnitFilterBtnHm').removeClass("openFilter");
                //document.getElementById("sideNavHm").style.height = "0";
                //document.getElementById("sideNavHm").style.top = "0";
                //document.getElementById("sideNavHm").style.marginLeft = "0";
                //document.getElementById("RaHeatmapTabAML").style.marginTop = "0";
                //document.getElementById("sideNavHm").style.borderTop = "unset";
                $('#OrganizationalLevel').hide();
                $('#BuselectFilter').hide();
                $('#OrgFilterError').hide();
                $('#BUFilterError').hide();
                $('#loadingImgMainHm').modal('hide');
                $('#FilterButton').hide();
                HmViewModel.IsSideNavOpen(0);
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: closeSideNav() method in ResidualRiskHeatMap.js';
                logger.logMessage(msg);
            }
        }

        function BusinessUnitModelDUP(item) {
            try {
                var self = this;
                self.BusinessUnitId = ko.observable($('<div/>').html(item.BusinessUnitId()).text());
                self.BU_ID = ko.observable($('<div/>').html(item.BusinessUnitId()).text());
                self.BuId = ko.observable($('<div/>').html(item.BusinessUnitId()).text());
                self.BusinessUnitName = ko.observable($('<div/>').html(item.BusinessUnitName()).text());
                self.BuName = ko.observable($('<div/>').html(item.BusinessUnitName()).text());
                self.BU_NAME = ko.observable($('<div/>').html(item.BusinessUnitName()).text());
                self.AssessmentDate = ko.observable($('<div/>').html(item.AssessmentDate()).text());
                self.BuStatus = ko.observable($('<div/>').html(item.BuStatus()).text());
                self.SubLevelId = ko.observable(item.SubLevelId());
                self.isChecked = ko.observable(false);
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: BusinessUnitModel() method in ResidualRiskHeatMap.js';
                logger.logMessage(msg);
            }
        }

        function SubCheckboxSelected(data, event) {
            try {
                $('#OrgFilterError').hide();
                $('#BUFilterError').hide();
                var selectedSubOrgLevelID = event.currentTarget.id.substr(event.currentTarget.id.indexOf("el") + 2);
                var BUselected = "";
                if (isNaN(parseInt(selectedSubOrgLevelID)) && HmViewModel.SelectedCheckedList().length > 0) {
                    $('#BUFilterError').show();
                    return false;
                }
                else if (!isNaN(parseInt(selectedSubOrgLevelID)) && HmViewModel.SelectedCheckedBUList().length > 0) {
                    $('#OrgFilterError').show();
                    return false;
                }
                else if (!isNaN(parseInt(selectedSubOrgLevelID)) && HmViewModel.SelectedCheckedBUList().length == 0) {
                    for (var i = 0; i < HmViewModel.OrgLvlDrpDwnList().length; i++) {
                        var counterCheck = 0;
                        for (var g = 0; g < HmViewModel.OrgLvlDrpDwnList()[i].BusinessLevelValueList().length; g++) {
                            if (HmViewModel.OrgLvlDrpDwnList()[i].BusinessLevelValueList()[g].BlvalueId() == selectedSubOrgLevelID) {
                                if (event.currentTarget.checked) {
                                    $("#sublevel" + HmViewModel.OrgLvlDrpDwnList()[i].BusinessLevelValueList()[g].BlvalueId()).prop("checked", true);
                                    $('.fa-check.' + HmViewModel.OrgLvlDrpDwnList()[i].BusinessLevelValueList()[g].BlvalueId()).css({ 'display': 'inline-block' });

                                    HmViewModel.SelectedCheckedList.push({
                                        SubLevelId: HmViewModel.OrgLvlDrpDwnList()[i].BusinessLevelValueList()[g].BlvalueId(),
                                        SubLevelName: HmViewModel.OrgLvlDrpDwnList()[i].BusinessLevelValueList()[g].BlvalueName(),
                                        OrgLevelName: HmViewModel.OrgLvlDrpDwnList()[i].BlName()
                                    });
                                }
                                else {
                                    $("#sublevel" + HmViewModel.OrgLvlDrpDwnList()[i].BusinessLevelValueList()[g].BlvalueId()).prop("checked", false);
                                    $('.fa-check.' + HmViewModel.OrgLvlDrpDwnList()[i].BusinessLevelValueList()[g].BlvalueId()).css({ 'display': 'none' });
                                    if (HmViewModel.SelectedCheckedList().length > 0) {
                                        HmViewModel.SelectedCheckedList.remove(function (item) { return item.SubLevelId == HmViewModel.OrgLvlDrpDwnList()[i].BusinessLevelValueList()[g].BlvalueId() })
                                    }
                                }
                            }

                            //Mark parent check box as checked if all sub levels are selected
                            if ($("#sublevel" + HmViewModel.OrgLvlDrpDwnList()[i].BusinessLevelValueList()[g].BlvalueId()).prop('checked')) {
                                counterCheck++;
                            }
                            if (counterCheck > 0 && counterCheck == HmViewModel.OrgLvlDrpDwnList()[i].BusinessLevelValueList().length) {
                                $("#" + HmViewModel.OrgLvlDrpDwnList()[i].BlId()).prop("checked", true);
                            }
                            else if (counterCheck > 0 && counterCheck == HmViewModel.OrgLvlDrpDwnList()[i].BusinessLevelValueList().length) {
                                $("#" + HmViewModel.OrgLvlDrpDwnList()[i].BlId()).prop("checked", false);
                            }
                        }
                    }
                    //Logic to re-set the BU list
                    HmViewModel.BusinessUnitListForFilters([]);
                    if (HmViewModel.SelectedCheckedList().length > 0) {
                        var mappedBuList = $.map(HmViewModel.BusinessUnitListForFiltersDUP(), function (result) {
                            for (var m = 0; m < HmViewModel.SelectedCheckedList().length; m++) {
                                if (result.SubLevelId() == HmViewModel.SelectedCheckedList()[m].SubLevelId)
                                    return new BusinessUnitModelDUP(result);
                            }
                        });
                        HmViewModel.BusinessUnitListForFilters(mappedBuList);
                        //Main tain this list to retain the org filters on deselection of applicability filters
                        HmViewModel.FinalOrgFilterList(mappedBuList);

                    }
                    else {
                        HmViewModel.BusinessUnitListForFilters([]);
                        mappedBuList = $.map(HmViewModel.BusinessUnitListForFiltersDUP(), function (result) {
                            return new BusinessUnitModelDUP(result);
                        });
                        HmViewModel.BusinessUnitListForFilters(mappedBuList);
                        HmViewModel.FinalOrgFilterList(mappedBuList);
                    }
                    SetFilterSelection();

                } else if (isNaN(parseInt(selectedSubOrgLevelID)) && HmViewModel.SelectedCheckedList().length == 0) {
                    BUselected = event.currentTarget.id.substr(event.currentTarget.id.indexOf("BU") + 2);

                    for (var i = 0; i < HmViewModel.BusinessUnitListDUP().length; i++) {
                        if (HmViewModel.BusinessUnitListDUP()[i].BusinessUnitId() == BUselected) {
                            if (event.currentTarget.checked) {
                                $("#sublevelBU" + BUselected).prop("checked", true);
                                $('.fa-check.' + BUselected).css({ 'display': 'inline-block' });

                                HmViewModel.SelectedCheckedBUList.push({
                                    SubLevelId: HmViewModel.BusinessUnitListDUP()[i].BusinessUnitId(),
                                    SubLevelName: HmViewModel.BusinessUnitListDUP()[i].BusinessUnitName()
                                });
                            }
                            else {
                                $("#sublevelBU" + BUselected).prop("checked", false);
                                $('.fa-check.' + BUselected).css({ 'display': 'none' });
                                if (HmViewModel.SelectedCheckedBUList().length > 0) {
                                    HmViewModel.SelectedCheckedBUList.remove(function (item) { return item.SubLevelId == HmViewModel.BusinessUnitListDUP()[i].BusinessUnitId() })
                                }
                            }
                        }
                    }

                    if (HmViewModel.SelectedCheckedBUList().length > 0) {
                        //Logic to re-set the BU list
                        HmViewModel.BusinessUnitListForFilters([]);

                        var mappedBuList = $.map(HmViewModel.BusinessUnitListDUP(), function (result) {
                            for (var m = 0; m < HmViewModel.SelectedCheckedBUList().length; m++) {
                                if (result.BusinessUnitId() == HmViewModel.SelectedCheckedBUList()[m].SubLevelId)
                                    return new BusinessUnitModelDUP(result);
                            }
                        });
                        HmViewModel.BusinessUnitListForFilters(mappedBuList);
                    }
                    else {
                        HmViewModel.BusinessUnitListForFilters([]);
                        var mappedBuList = $.map(HmViewModel.BusinessUnitListForFiltersDUP(), function (result) {
                            return new BusinessUnitModelDUP(result);
                        });
                        HmViewModel.BusinessUnitListForFilters(mappedBuList);
                        HmViewModel.FinalOrgFilterList(mappedBuList);
                    }
                    SetBUFilterSelection();
                }
                //Set count of BU's selected
                if (HmViewModel.BusinessUnitListForFilters().length > 0) {
                    HmViewModel.DistinctFileredBUs = ko.dependentObservable(function () {
                        var seen = [];
                        return HmViewModel.BusinessUnitListForFilters().filter(function (n) {
                            return seen.indexOf(n.BusinessUnitId()) == -1 && seen.push(n.BusinessUnitId());
                        });
                    });
                    HmViewModel.BusinessUnitListForFilters(HmViewModel.DistinctFileredBUs());
                }

                HmViewModel.NumberOfBUsSelected(HmViewModel.BusinessUnitListForFilters().length)
            }
            catch (e) {
                var msg = 'Exception' + e + ' | Source: SubCheckboxSelected function in ResidualRiskHeatMap.js';
                logger.logMessage(msg);
            }
        }

        function SetBUFilterSelection() {
            try {
                document.getElementById('DynamicOrgOptedFilters').innerHTML = "";

                var contentHtml = "";
                for (var k = 0; k < HmViewModel.SelectedCheckedBUList().length; k++) {
                    contentHtml += '<div id="DynamicBUOptedFilters_' + HmViewModel.SelectedCheckedBUList()[k].SubLevelId + '" class="fitem"><span class="hetamap-filter"><span>BU </span> : ' + HmViewModel.SelectedCheckedBUList()[k].SubLevelName + '<span id="ClearFilterTextBU_' + HmViewModel.SelectedCheckedBUList()[k].SubLevelId + '" data-bind="click:ClearBUFilterSelection" class="f-clear"><i class="demo-icon icon-cross_special"></i></span></span></div>';
                }

                document.getElementById('DynamicOrgOptedFilters').innerHTML = contentHtml;
                for (var k = 0; k < HmViewModel.SelectedCheckedBUList().length; k++) {
                    ko.applyBindingsToNode($('#ClearFilterTextBU_' + HmViewModel.SelectedCheckedBUList()[k].SubLevelId), { click: HmViewModel.ClearBUFilterSelection }, HmViewModel);
                }
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: SetBUFilterSelection() method in ResidualRiskHeatMap.js';
                logger.logMessage(msg);
            }
        }

        function ClearBUFilterSelection(data, event) {
            try {

                var selectedSubOrgLevelID = event.currentTarget.id.substr(event.currentTarget.id.indexOf("_") + 1);
                document.getElementById('DynamicBUOptedFilters_' + selectedSubOrgLevelID).innerHTML = "";

                $('.fa-check.' + selectedSubOrgLevelID).css({ 'display': 'none' });
                if (HmViewModel.SelectedCheckedBUList().length > 0) {
                    HmViewModel.SelectedCheckedBUList.remove(function (item) { return item.SubLevelId == selectedSubOrgLevelID })
                }

                //Logic to re-set the BU list
                HmViewModel.BusinessUnitListForFilters([]);
                if (HmViewModel.SelectedCheckedBUList().length > 0) {
                    var mappedBuList = $.map(HmViewModel.BusinessUnitListForFiltersDUP(), function (result) {
                        for (var m = 0; m < HmViewModel.SelectedCheckedBUList().length; m++) {
                            if (result.BusinessUnitId() == HmViewModel.SelectedCheckedBUList()[m].SubLevelId)
                                return new BusinessUnitModelDUP(result);
                        }
                    });
                    HmViewModel.BusinessUnitListForFilters(mappedBuList);

                }
                else {
                    HmViewModel.BusinessUnitListForFilters([]);
                    var mappedBuList = $.map(HmViewModel.BusinessUnitListForFiltersDUP(), function (result) {
                        return new BusinessUnitModelDUP(result);
                    });
                    HmViewModel.BusinessUnitListForFilters(mappedBuList);

                    $('#OrgFilterError').hide();
                }
                //Set count of BU's selected
                if (HmViewModel.BusinessUnitListForFilters().length > 0) {
                    HmViewModel.DistinctFileredBUs = ko.dependentObservable(function () {
                        var seen = [];
                        return HmViewModel.BusinessUnitListForFilters().filter(function (n) {
                            return seen.indexOf(n.BusinessUnitId()) == -1 && seen.push(n.BusinessUnitId());
                        });
                    });
                    HmViewModel.BusinessUnitListForFilters(HmViewModel.DistinctFileredBUs());
                }

                HmViewModel.NumberOfBUsSelected(HmViewModel.BusinessUnitListForFilters().length);
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ClearBUFilterSelection() method in ResidualRiskHeatMap.js';
                logger.logMessage(msg);
            }
        }

        function SetFilterSelection() {
            try {
                document.getElementById('DynamicOrgOptedFilters').innerHTML = "";
                //Mark Org levels filter seletion
                var contentHtml = "";
                for (var k = 0; k < HmViewModel.SelectedCheckedList().length; k++) {
                    contentHtml += '<div id="DynamicOptedFilters_' + HmViewModel.SelectedCheckedList()[k].SubLevelId + '" class="fitem"><span class="hetamap-filter"><span>' + HmViewModel.SelectedCheckedList()[k].OrgLevelName + '</span> : ' + HmViewModel.SelectedCheckedList()[k].SubLevelName + '<span id="ClearFilterText_' + HmViewModel.SelectedCheckedList()[k].SubLevelId + '" data-bind="click:ClearOrgFilterSelection" ><i class="demo-icon icon-cross_special"></i></span></span></div>';
                }
                document.getElementById('DynamicOrgOptedFilters').innerHTML = contentHtml;
                for (var k = 0; k < HmViewModel.SelectedCheckedList().length; k++) {
                    ko.applyBindingsToNode($('#ClearFilterText_' + HmViewModel.SelectedCheckedList()[k].SubLevelId), { click: HmViewModel.ClearOrgFilterSelection }, HmViewModel);
                }
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ClearOrgFilterSelection() method in ResidualRiskHeatMap.js';
                logger.logMessage(msg);
            }
        }

        function attached() {
            try {

                var Id = HmViewModel.appsecurity.getParameterByName('atype');
                HmViewModel.AssessmentTypeId(Id);
                HmViewModel.appsecurity.GetAssessmentNames().then(function () {
                    HmViewModel.AssessmentType(HmViewModel.appsecurity.GetAssessmentName(HmViewModel.AssessmentTypeId()))
                    HmViewModel.ScreenName(HmViewModel.AssessmentType() + ' Residual Risk Heatmap');
                })
                var parent = $(location).attr('href').split('/').pop();
                $('#expheatmapHm').show();

                HmViewModel.riskType('I');
                $('#expandA').hide();
                $('#collapseA').show();

                if (parent.split('?')[0] == 'CRAResidualsRiskHeatMap') {
                    HmViewModel.ComposeBindingFlag(false);
                    if (HmViewModel.expandCollapseColumns().length > 0)
                        HmViewModel.expandCollapseColumns.removeAll();

                    HmViewModel.expandCollapseColumns.push(new expandCollapseModel({ colType: "Inherent" }));
                    HmViewModel.expandCollapseColumns.push(new expandCollapseModel({ colType: "Controls" }));
                    HmViewModel.expandCollapseColumns.push(new expandCollapseModel({ colType: "Residual" }));
                    GetBusinessLevel();

                }
                else {
                    $("#BusinessUnitFilterBtnHm").hide();
                    $("#expheatmapHm").hide();
                    $("#myDropdownSort").hide();
                    HmViewModel.ComposeBindingFlag(true);
                    $("#MainInherentHeatMapDiv").css({ 'overflow-y': 'scroll', 'height': '50vh' });
                }
                HmViewModel.SelectedCheckedBUList([]);
                HmViewModel.SelectedCheckedList([]);
                HmViewModel.SelectedBUs('');
                closeSideNav();
                HmViewModel.BUFiltersApplied(false);
                HmViewModel.NumberOfBUsSelected(0);
                $('.badge').css({ 'display': 'none' });


            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: attached() method in CRAResidualRiskHeatMap.js';
                logger.logMessage(msg);
            }
        }


        function sortResetDefault(data, event) {
            try {
                $('.fa-check.1').css({ 'display': 'none' });
                $('.fa-check.2').css({ 'display': 'none' });
                $('.fa-check.3').css({ 'display': 'none' });
                $('.fa-check.4').css({ 'display': 'none' });
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: sortResetDefault() method in ResidualRiskHeatMap.js';
                logger.logMessage(msg);
            }
        }


        function expandCollapseModel(item) {
            var self = this;
            self.colName = ko.observable("Collapse " + item.colType + " cells");
            self.isExpanded = ko.observable("table-cell");
            self.expand = function (data, e) {
                if (data.isExpanded() == "table-cell") {
                    self.colName = ko.observable("Expand " + item.colType + " cells");
                    self.isExpanded("none");
                    if (HmViewModel.ColspanValue() == 3) {
                        HmViewModel.ColspanValue(2)
                    }
                }
                else {
                    self.colName = ko.observable("Collapse " + item.colType + " cells");
                    self.isExpanded("table-cell");
                    if (HmViewModel.ColspanValue() == 2) {
                        HmViewModel.ColspanValue(3)
                    }
                }
            }
        }
        function BusinessLevelsModel(item) {
            try {
                var self = this;
                self.Bulevel = ko.observable($('<div/>').html(item.Bulevel).text());
                self.BlName = ko.observable($('<div/>').html(item.BlName).text());
                self.BlId = ko.observable(item.BlId)
                var MappedBuLevelValueList = $.map(item.BuLevelValueList, function (result) {
                    return new BuLevelValueListModel(result);
                });
                self.BusinessLevelValueList = ko.observableArray(MappedBuLevelValueList);
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: BusinessLevelModel() method in ResidualRiskHeatMap.js';
                logger.logMessage(msg);
            }
        }

        function BindHTML() {
            try {
                //Org Level Filter Fossil style
                var OrgList = "";

                OrgList += '<div class="filter-nav1"><ul class="nav nav-tabs"><li class="fl-lbl"><span>Add Filters </span> </li>';

                for (var i = 0; i < HmViewModel.OrgLvlDrpDwnList().length; i++) {
                    if (i == 0) {
                        OrgList += '<li class="active"><a href="#tab_' + HmViewModel.OrgLvlDrpDwnList()[i].BlId() + '" data-toggle="tab">' + HmViewModel.OrgLvlDrpDwnList()[i].BlName() + ' <i class="fa fa-chevron-down" aria-hidden="true"></i> </a></li>'
                    } else {
                        OrgList += '<li class=""><a href="#tab_' + HmViewModel.OrgLvlDrpDwnList()[i].BlId() + '" data-toggle="tab">' + HmViewModel.OrgLvlDrpDwnList()[i].BlName() + ' <i class="fa fa-chevron-down" aria-hidden="true" ></i> </a></li>'
                    }
                }
                OrgList += '<li class=""><a href="#tab_BU" data-toggle="tab">' + HmViewModel.BUTitle() + ' <i class="fa fa-chevron-down" aria-hidden="true"></i> </a></li>'

                OrgList += '</ul><div class="tab-content filter-content">';

                for (var i = 0; i < HmViewModel.OrgLvlDrpDwnList().length; i++) {
                    if (i == 0) {
                        OrgList += '<div class="tab-pane active" id="tab_' + HmViewModel.OrgLvlDrpDwnList()[i].BlId() + '">'
                    } else {
                        OrgList += '<div class="tab-pane" id="tab_' + HmViewModel.OrgLvlDrpDwnList()[i].BlId() + '">'
                    }

                    if (HmViewModel.OrgLvlDrpDwnList()[i].BusinessLevelValueList().length > 0) {

                        for (var j = 0; j < HmViewModel.OrgLvlDrpDwnList()[i].BusinessLevelValueList().length; j++) {
                            OrgList += '<label  class="ft-selection"><input id=sublevel' + HmViewModel.OrgLvlDrpDwnList()[i].BusinessLevelValueList()[j].BlvalueId() + ' type="checkbox" data-bind="event:{change:$root.SubCheckboxSelected}" style="font-weight: 600;position : fixed;clip : rect(0,0,0,0);pointer-events : none;"><i class="fa fa-check ' + HmViewModel.OrgLvlDrpDwnList()[i].BusinessLevelValueList()[j].BlvalueId() + '" aria-hidden="true" style="display:none"></i><span class="cc-facet-result-text tag-text">' + HmViewModel.OrgLvlDrpDwnList()[i].BusinessLevelValueList()[j].BlvalueName() + '</span></label>';
                        }

                    }
                    OrgList += '</div>';
                }
                OrgList += '<div class="tab-pane" id="tab_BU">';

                HmViewModel.DistinctFileredBUs = ko.dependentObservable(function () {
                    var seen = [];
                    return HmViewModel.BusinessUnitListForFilters().filter(function (n) {
                        return seen.indexOf(n.BusinessUnitId()) == -1 && seen.push(n.BusinessUnitId());
                    });
                });

                HmViewModel.BusinessUnitListForFilters(HmViewModel.DistinctFileredBUs());

                for (var w = 0; w < HmViewModel.BusinessUnitListForFilters().length; w++) {
                    OrgList += '<label class="ft-selection">' +
                        '<input id=sublevelBU' + HmViewModel.BusinessUnitListForFilters()[w].BusinessUnitId() + ' type="checkbox" data-bind="event:{change:$root.SubCheckboxSelected}" style="font-weight: 600;position : fixed;clip : rect(0,0,0,0);pointer-events : none;">' +
                        '<i class="fa fa-check ' + HmViewModel.BusinessUnitListForFilters()[w].BusinessUnitId() + '" aria-hidden="true" style="display:none"></i>' +
                        '<span class="cc-facet-result-text tag-text">' + HmViewModel.BusinessUnitListForFilters()[w].BusinessUnitName() + '</span>' +
                        '</label>';
                }
                OrgList += '</div>';

                if (OrgList == "") {
                    OrgList = '<div id="NoorganizationalLevelerror" class="alert-warning"><label class="control-label">Organizational Levels are not configured for this Year of Assessment.</label></div>';

                }
                document.getElementById('OrganizationalLevel').innerHTML = OrgList;

                for (var i = 0; i < HmViewModel.OrgLvlDrpDwnList().length; i++) {
                    for (var l = 0; l < HmViewModel.OrgLvlDrpDwnList()[i].BusinessLevelValueList().length; l++) {
                        ko.applyBindingsToNode($('#sublevel' + HmViewModel.OrgLvlDrpDwnList()[i].BusinessLevelValueList()[l].BlvalueId()), { event: { change: HmViewModel.SubCheckboxSelected } }, HmViewModel);
                    }
                }

                for (var k = 0; k < HmViewModel.BusinessUnitListForFilters().length; k++) {
                    ko.applyBindingsToNode($('#sublevelBU' + HmViewModel.BusinessUnitListForFilters()[k].BusinessUnitId()), { event: { change: HmViewModel.SubCheckboxSelected } }, HmViewModel);
                }
                $('#loadingImgMainHm').modal('hide');
                HmViewModel.NumberOfBUsSelected(HmViewModel.BusinessUnitListForFilters().length);
            }
            catch (e) {
                var msg = 'Exception' + e + ' | Source: BindHTML function in ResidualRiskHeatMap.js';
                logger.logMessage(msg);
            }
        }


        function GetAllOrganizationalLevels() {
            try {
                return $.ajax({
                    url: "/api/Configuration/getDistinctBusinessLevelsAllBUApplicability",
                    type: "GET",
                    headers: appsecurity.getSecurityHeaders(),
                    data: { TypeId: HmViewModel.AssessmentTypeId(), YOA: null }
                })
                    .success(ajaxSuccess)
                    .fail(ajaxFail)
            }

            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ajax call in GetAllOrganizationalLevels() in ResidualRiskHeatMap.js';
                logger.logMessage(msg);

            }

            function ajaxSuccess(jsonResult, status) {
                try {
                    if (jsonResult != null) {
                        var OrganizationalLevels = $.map(jsonResult, function (result) {
                            return new BusinessLevelsModel(result);
                        });
                        if (OrganizationalLevels.length > 0) {
                            HmViewModel.OrgLvlDrpDwnList(OrganizationalLevels);
                            HmViewModel.OrgLvlValueList(HmViewModel.OrgLvlDrpDwnList()[0].BusinessLevelValueList());
                        }
                        //Get all BU list with org sub level id's
                        GetAllBusinessUnitsForFilters();
                        HmViewModel.SelectedCheckedList([]);
                        HmViewModel.SelectedCheckedBUList([]);
                        document.getElementById('DynamicOrgOptedFilters').innerHTML = "";
                    }
                    else
                        logger.logError('An error occurred. Please contact your Application Administrator.', 'Error', system.getModuleId(HmViewModel), true);
                }
                catch (e) {
                    var msg = 'Exception: ' + e + ' | Source: ajaxSuccess in GetAllOrganizationalLevels() in ResidualRiskHeatMap.js';
                    logger.logMessage(msg);
                }
            }

            function ajaxFail(error, status) {
                try {
                    if (error.status == 401) {
                        app.showMessage("You have been logged out. Please login again to complete the operation.", "Error in Edit Operation", ["OK"], false, { buttonClass: "fa fa-times btn btn-default", primaryButtonClass: "fa fa-check btn btn-success autofocus", secondaryButtonClass: "", "class": "modal-content messageBox", style: null, popupIcon: 'title-icon col-md-1 fa fa-login' })
                            .then(function (option) {
                                if (option == "OK")
                                    navigation.unauthorized();
                            })
                    }
                    else {
                        var msg = 'Exception: ' + error.statusText + ' | Source: ajaxFail in GetAllOrganizationalLevels() method in ResidualRiskHeatMap.js';
                        logger.logMessage(msg);
                    }
                }
                catch (e) {
                    var msg = 'Exception: ' + e + ' | Source: ajaxFail in GetAllOrganizationalLevels() method in ResidualRiskHeatMap.js';
                    logger.logMessage(msg);
                }
            }
        }

        function BuLevelValueListModel(item) {
            try {
                var self = this;
                self.BlvalueId = ko.observable($('<div/>').html(item.BlvalueId).text());
                self.BlvalueName = ko.observable($('<div/>').html(item.BlvalueName).text());
                self.ParentBuLevel = ko.observable($('<div/>').html(item.ParentBuLevel).text());
                self.BlvalueShortName = ko.observable($('<div/>').html(item.BlvalueShortName).text());
                self.TargetRow = ko.observable(item.TargetRow);
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: BuLevelValueListModel() method in ResidualRiskHeatMap.js';
                logger.logMessage(msg);
            }
        }

        function GetAllBusinessUnitsForFilters() {
            try {

                return $.ajax({
                    url: "/api/AMLRiskAssessment/GetAllBusinessUnitsForFiltersBUApplicability",
                    type: "GET",
                    headers: appsecurity.getSecurityHeaders(),
                    data: { TypeId: HmViewModel.AssessmentTypeId() }
                })
                    .success(ajaxSuccess)
                    .fail(ajaxFail)
            }

            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ajax caLL in GetAllBusinessUnitsForFilters() in ResidualRiskHeatMap.js';
                logger.logMessage(msg);

            }

            function ajaxSuccess(jsonResult, status) {
                try {
                    if (jsonResult != null) {
                        var mappedBuList = $.map(jsonResult, function (result) {
                            return new BusinessUnitModelFilter(result);
                        });
                        HmViewModel.BusinessUnitListForFilters(mappedBuList);
                        HmViewModel.BusinessUnitListForFiltersDUP(mappedBuList);

                        HmViewModel.BusinessUnitListDUP = ko.dependentObservable(function () {
                            var seen = [];
                            return mappedBuList.filter(function (n) {
                                return seen.indexOf(n.BusinessUnitId()) == -1 && seen.push(n.BusinessUnitId());
                            });
                        });
                        BindHTML();
                        $('#OrgFilterError').hide();
                        $('#BUFilterError').hide();
                        //document.getElementById("sideNavHm").style.top = "unset";
                        //document.getElementById("sideNavHm").style.borderTop = "unset";
                        //document.getElementById("sideNavHm").style.borderBottom = "1px solid #000";
                        //document.getElementById("sideNavHm").style.width = "98.5%";
                        //document.getElementById("sideNavHm").style.marginLeft = "1.2rem";
                        //document.getElementById("sideNavHm").style.height = "28%";
                    }
                    else
                        logger.logError('An error occurred. Please contact your Application Administrator.', 'Error', system.getModuleId(HmViewModel), true);
                }
                catch (e) {
                    var msg = 'Exception: ' + e + ' | Source: ajaxSuccess in GetAllBusinessUnitsForFilters() in ResidualRiskHeatMap.js';
                    logger.logMessage(msg);
                }
            }

            function ajaxFail(error, status) {
                try {
                    if (error.status == 401) {
                        app.showMessage("You have been logged out. Please login again to complete the operation.", "Error in Edit Operation", ["OK"], false, { buttonClass: "fa fa-times btn btn-default", primaryButtonClass: "fa fa-check btn btn-success autofocus", secondaryButtonClass: "", "class": "modal-content messageBox", style: null, popupIcon: 'title-icon col-md-1 fa fa-login' })
                            .then(function (option) {
                                if (option == "OK")
                                    navigation.unauthorized();
                            })
                    }
                    else {
                        var msg = 'Exception: ' + error.statusText + ' | Source: ajaxFail in GetAllBusinessUnitsForFilters() method in ResidualRiskHeatMap.js';
                        logger.logMessage(msg);
                    }
                }
                catch (e) {
                    var msg = 'Exception: ' + e + ' | Source: ajaxFail in GetAllBusinessUnitsForFilters() method in ResidualRiskHeatMap.js';
                    logger.logMessage(msg);
                }
            }
        }

        //Apply filter event
        function ApplyBuFilters(data, event) {
            try {
                HmViewModel.SelectedBUs('');
                var SelectedBUsString = "";
                for (var i = 0; i < data.BusinessUnitListForFilters().length; i++) {
                    if (SelectedBUsString === "")
                        SelectedBUsString = data.BusinessUnitListForFilters()[i].BU_ID().toString();
                    else
                        SelectedBUsString += "," + data.BusinessUnitListForFilters()[i].BU_ID().toString();
                }
                HmViewModel.SelectedBUs(SelectedBUsString);
                HmViewModel.BUFiltersApplied(true);
                getHeatMapData();
                //for (var i = 0; i < HmViewModel.SelectedBUs().length; i++){
                //    var hdata = ko.utils.arrayFilter(HmViewModel.HeatmapDatadup.businessUnitsModel, function (param) {

                //        if (param.BU_ID == HmViewModel.SelectedBUs()[i])
                //            return param;

                //    });             
                //}
                closeSideNav();
               
                HmViewModel.NumberOfBUsSelected(data.BusinessUnitListForFilters().length);
                $('.badge').css({ 'display': 'inline-block' });
                sortResetDefault();
                $('#myDropdown').removeClass('show');
                $('#myDropdownSort').removeClass('open');
                $("#f-filter").css("display", "");
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ApplyBuFilters() method in ResidualRiskHeatMap.js';
                logger.logMessage(msg);
            }
        }

        //clear filter event
        function ClearAllBuFilters(data, event) {
            try {
                HmViewModel.BusinessUnitList(HmViewModel.BusinessUnitListDUP());
                HmViewModel.SelectedCheckedBUList([]);
                HmViewModel.SelectedCheckedList([]);
                HmViewModel.SelectedBUs('');
                closeSideNav();
                HmViewModel.BUFiltersApplied(false);
                HmViewModel.NumberOfBUsSelected(0);
                $('.badge').css({ 'display': 'none' });
                document.getElementById('DynamicOrgOptedFilters').innerHTML = "";
                $('#DynamicOrgOptedFilters').css({ 'display': 'none' });
                $('#f-filter').css('display', 'none');
                getHeatMapData();
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ClearAllBuFilters() method in ResidualRiskHeatMap.js';
                logger.logMessage(msg);
            }
        }

        function openSideNav() {
            try {
                $('#myValueDropdown').removeClass('show');
                $('#myValueDropdownSort').removeClass('open');
                $('#myDropdown').removeClass('show');
                $('#myDropdownSort').removeClass('open');
                $('#exportDropdown').removeClass('show');
                $('#exportDropdownBtn').removeClass('open');
                $('#myValueDropdownLevel').removeClass('show');
                $('#myValueDropdownSortLevel').removeClass('open');

                if ($('#BusinessUnitFilterBtnHm').hasClass("openFilter")) {
                    closeSideNav();
                } else {
                    $('#BusinessUnitFilterBtnHm').addClass("openFilter");
                    $('#OrganizationalLevel').show();
                    $('#BuselectFilter').show();
                    $('#FilterButton').show();
                    $('#OrgFilterError').hide();
                    $('#BUFilterError').hide();
                    if (HmViewModel.BUFiltersApplied() == false) {
                        $('#loadingImgMainHm').modal('show');
                        GetAllOrganizationalLevels();
                    }
                    else {
                        //document.getElementById("sideNavHm").style.top = "unset";
                        //document.getElementById("RaHeatmapTabAML").style.marginTop = "28rem";
                        //document.getElementById("sideNavHm").style.borderBottom = "1px solid #000";
                        //document.getElementById("sideNavHm").style.height = "28%";
                    }
                }
                HmViewModel.IsSideNavOpen(1);
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: openSideNav() method in ResidualRiskHeatMap.js';
                logger.logMessage(msg);
            }
        }

        function GetBusinessLevel() {
            try {
                return $.ajax({
                    url: "/api/Configuration/getAllBusinessUnitLevels?type=" + HmViewModel.AssessmentTypeId() + "&Page_Type=RH",
                    type: "GET",
                    headers: appsecurity.getSecurityHeaders()
                })
                    .success(ajaxSuccess)
                    .fail(ajaxFail)
            } catch (e) {

                var msg = 'Exception: ' + e + ' | Source: ajax call in GetBusinessLevel() method in CRAResidualRiskHeatMap.js';
                logger.logMessage(msg);
            }
            function ajaxSuccess(jsonResult, status) {
                try {
                    if (jsonResult != null) {
                        HmViewModel.BusinessLevel(jsonResult.length);
                        var MappedBUModelList = $.map(jsonResult, function (result) {
                            var BusinessLevelModelObj = new BusinessLevelModel(result);
                            return BusinessLevelModelObj;
                        });

                        HmViewModel.BusinessLevelList(MappedBUModelList);
                        $('#RaHeatmapTabAML').tabs();
                        $('#RaHeatmapTabAML').tabs('refresh');
                        $('#RaHeatmapTabAML').tabs({ active: 0 });
                        $($('#RiskAreaHeatmapAMLUl li').get(0)).trigger('click');
                        scrollableTabs();
                    }
                    else
                        logger.logError('An error occurred. Please contact your Application Administrator.', 'Error', system.getModuleId(HmViewModel), true);
                }
                catch (e) {
                    var msg = 'Exception: ' + e + ' | Source: ajaxSuccess call in GetBusinessLevel() method in CRAResidualRiskHeatMap.js';
                    logger.logMessage(msg);
                }
            }
            function ajaxFail(error, status) {
                try {

                    if (error.status == 401) {
                        app.showMessage("You have been logged out. Please login again to complete the operation.", "Error in Edit Operation", ["OK"], false, { buttonClass: "fa fa-times btn btn-default", primaryButtonClass: "fa fa-check btn btn-success autofocus", secondaryButtonClass: "", "class": "modal-content messageBox", style: null, popupIcon: 'title-icon col-md-1 fa fa-login' })
                            .then(function (option) {
                                if (option == "OK")
                                    navigation.unauthorized();

                            })
                    }
                    else {
                        var msg = 'Exception: ' + error.statusText + ' | Source: ajaxFail in GetBusinessLevel() method in CRAResidualRiskHeatMap.js';
                        logger.logMessage(msg);
                    }
                } catch (e) {
                    var msg = 'Exception: ' + e + ' | Source: ajaxFail in GetBusinessLevel() method in CRAResidualRiskHeatMap.js';
                    logger.logMessage(msg);
                }
            }

        }
        function detached() {
            try {
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: detached() method in CRAResidualRiskHeatMap.js';
                logger.logMessage(msg);
            }
        };


        function clickLevel(data, event) {
            try {
                if (HmViewModel.InhRiskThemeDetails()[data.Index].LevelState == false) {
                    $("#spandown" + data.Id).hide();
                    $("#spanright" + data.Id).show();
                    if (HmViewModel.InhRiskThemeDetails() != undefined)
                        HmViewModel.InhRiskThemeDetails()[data.Index].LevelState = true;

                    if (data.LevelId != data.MaxLevel) {
                        for (var i = 0; i < HmViewModel.Multilist().length; i++) {
                            if (data.LevelId > HmViewModel.Multilist()[i].LevelId && HmViewModel.Multilist()[i].childHeatMapData != null && HmViewModel.Multilist()[i].childHeatMapData.length > 0) {
                                LastLevelHide(HmViewModel.Multilist()[i].childHeatMapData, data);
                            } else if (data.LevelId == HmViewModel.Multilist()[i].LevelId) {
                                if (data.Id == HmViewModel.Multilist()[i].Id) {
                                    if (HmViewModel.Multilist()[i].childHeatMapData != null && HmViewModel.Multilist()[i].childHeatMapData.length > 0) {
                                        RepeatTillLastLevelHide(HmViewModel.Multilist()[i].childHeatMapData);
                                    }
                                }
                            }
                        }
                    }

                }
                else {
                    $("#spandown" + data.Id).show();
                    $("#spanright" + data.Id).hide();
                    if (HmViewModel.InhRiskThemeDetails() != undefined)
                        HmViewModel.InhRiskThemeDetails()[data.Index].LevelState = false;


                    if (data.LevelId != data.MaxLevel) {
                        for (var i = 0; i < HmViewModel.Multilist().length; i++) {
                            if (data.LevelId > HmViewModel.Multilist()[i].LevelId && HmViewModel.Multilist()[i].childHeatMapData != null && HmViewModel.Multilist()[i].childHeatMapData.length > 0) {
                                LastLevelShow(HmViewModel.Multilist()[i].childHeatMapData, data);
                            } else if (data.LevelId == HmViewModel.Multilist()[i].LevelId) {
                                if (data.Id == HmViewModel.Multilist()[i].Id) {
                                    if (HmViewModel.Multilist()[i].childHeatMapData != null && HmViewModel.Multilist()[i].childHeatMapData.length > 0) {
                                        RepeatTillLastLevelShow(HmViewModel.Multilist()[i].childHeatMapData, data);
                                    }
                                }
                            }
                        }
                    }

                }
            } catch (e) {
                var msg = 'Exception: ' + e + ' | Source: clickLevel() method in CRAResidualRiskHeatMap.js';
                logger.logMessage(msg);
            }
        }

        function RepeatTillLastLevelShow(multiListData, clickedDataRow) {
            try {
                if (multiListData.length > 0) {
                    for (var j = 0; j < multiListData.length; j++) {
                        $(".taxo_" + multiListData[j].Id).show();
                        $('#spandown' + multiListData[j].Id).show();
                        $('#spanright' + multiListData[j].Id).hide();
                        //if (HmViewModel.Query() != "" && clickedDataRow.LevelId != HmViewModel.MaxTaxonomyLevel()) {
                        //    $(".taxo_" + multiListData[j].Id + ".childOf_" + clickedDataRow.Id).show();
                        //}

                        //if (HmViewModel.AssessmentType() == 2 && HmViewModel.OrgLevelFlag() && (HmViewModel.heatMapViewNA() == false) && (multiListData[j].Show_Edit == false)) {
                        //    $(".taxo_" + multiListData[j].Id + ".childOf_" + multiListData[j].PId).hide();
                        //}
                        if (multiListData[j].childHeatMapData != null && multiListData[j].childHeatMapData.length > 0) {
                            RepeatTillLastLevelShow(multiListData[j].childHeatMapData, clickedDataRow);
                        }
                    }
                }
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source:ajax call in RepeatTillLastLevel() method in SocR.js';
                logger.logMessage(msg);
            }
        }

        function RepeatTillLastLevelHide(multiListData) {
            try {
                if (multiListData.length > 0) {
                    for (var j = 0; j < multiListData.length; j++) {
                        $(".taxo_" + multiListData[j].Id).hide();
                        if (multiListData[j].childHeatMapData != null && multiListData[j].childHeatMapData.length > 0) {
                            RepeatTillLastLevelHide(multiListData[j].childHeatMapData);
                        }
                    }
                }
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source:ajax call in RepeatTillLastLevel() method in SocR.js';
                logger.logMessage(msg);
            }
        }

        function LastLevelShow(dataObjChild, clickedDataRow) {
            for (var i = 0; i < dataObjChild.length; i++) {
                if (clickedDataRow.LevelId == dataObjChild[i].LevelId && clickedDataRow.Id == dataObjChild[i].Id) {
                    RepeatTillLastLevelShow(dataObjChild[i].childHeatMapData, clickedDataRow);
                }
            }
        }

        function LastLevelHide(dataObjChild, clickedDataRow) {
            for (var i = 0; i < dataObjChild.length; i++) {
                if (clickedDataRow.LevelId == dataObjChild[i].LevelId && clickedDataRow.Id == dataObjChild[i].Id) {
                    RepeatTillLastLevelHide(dataObjChild[i].childHeatMapData);
                }
            }
        }


        //--------------------------------------------------------------------------Logic to Generate the Heat Map Starts----------------------------------------------------
        function BusinessLevelTabClick(data, event) {
            try {
                if (!HmViewModel.ComposeBindingFlag())
                    $('#expheatmapHm').show();

                $('#expheatmap').show();
                $('#MainInherentHeatMapDiv').hide();
                HmViewModel.ClickedBusinessLevelId(data.BusinessLevelId());
                HmViewModel.ClickedBusinessLevelName(data.BusinessLevelName());
                if (HmViewModel.ClickedBusinessLevelName().indexOf('Inherent') !== -1) {
                    HmViewModel.ClickedBusinessLevelId(0);
                }
                $('#error').hide();
                $('#loadingImgMainHm').modal('show');
                $('#RiskAreaHeatmapAMLUl li').removeClass('active');
                $('#' + data.BusinessLevelId()).addClass('active');

                getHeatMapData();

            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: BusinessLevelTabClick() method in CRAResidualRiskHeatMap.js';
                logger.logMessage(msg);
            }
        }

        function HeatmapThemeClick(data, event) {
            try {
                if (event.currentTarget.innerText == '+') {
                    $(event.target).text('-')

                    for (var i = 0; i < HmViewModel.HeatMapDataList().length; i++) {
                        if (HmViewModel.HeatMapDataList()[i].AreaId == event.currentTarget.id) {
                            for (var j = 0; j < HmViewModel.HeatMapDataList()[i].SubCategoryHeatMapList.length; j++) {
                                $('#Overalldatadiv' + event.currentTarget.id + '_' + HmViewModel.HeatMapDataList()[i].SubCategoryHeatMapList[j].SUB_AREA_ID).show()
                            }
                        }
                    }
                    $('#SubCategory' + event.currentTarget.id).hide();


                }
                else if (event.currentTarget.innerText == '-') {
                    $(event.target).text('+')
                    for (var i = 0; i < HmViewModel.HeatMapDataList().length; i++) {
                        if (HmViewModel.HeatMapDataList()[i].AreaId == event.currentTarget.id) {
                            for (var j = 0; j < HmViewModel.HeatMapDataList()[i].SubCategoryHeatMapList.length; j++) {
                                $('#Overalldatadiv' + event.currentTarget.id + '_' + HmViewModel.HeatMapDataList()[i].SubCategoryHeatMapList[j].SUB_AREA_ID).hide()
                            }
                        }
                    }
                    $('#SubCategory' + event.currentTarget.id).show();
                }

            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: HeatmapThemeClick() method in Activity.js';
                logger.logMessage(msg);
            }
        }
        function getHeatMapData() {
            try {
               $('#loadingImgOrCalc').show();
                $('#loadingImgMainHm').modal('show');
                $('#MainInherentHeatMapDiv').hide();
                if (HmViewModel.SelectedBUs() === undefined)
                    HmViewModel.SelectedBUs('');

                if ($("#TaxonomyLevelsId").val() != undefined)
                    selectedLevel = $("#TaxonomyLevelsId").val();

                $.ajax({
                    url: "/api/HeatMap/GetHeatMapDataCRA?AssessmentType=" + HmViewModel.AssessmentTypeId() +
                        "&LevelId=" + HmViewModel.ClickedBusinessLevelId() + "&RiskType=" + HmViewModel.riskType() +
                        "&SelectedBUs=" + HmViewModel.SelectedBUs(),
                    type: "GET",
                    headers: appsecurity.getSecurityHeaders()
                })
                    .success(ajaxSuccess)
                    .fail(ajaxFail);
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source:ajax call in getHeatMapData() method in CRAResidualRiskHeatMap.js';
                logger.logMessage(msg);
            }

            function ajaxSuccess(jsonResult, status) {
                try {
                    HmViewModel.HeatmapDatadup = jsonResult;
                    //  BindDynamicLevels();
                    $('#loadingImgMainHm').modal('hide');
                    if (jsonResult.businessUnitsModel.length === 0) {
                        $('#error').show();
                        $('#MainInherentHeatMapDiv').hide();
                        return;
                    }
                    else if (jsonResult !== null) {
                        // HmViewModel.dupheatmapdata(jsonResult);
                        $('#MainInherentHeatMapDiv').show();
                        $('#error').hide();
                        HmViewModel.ResHeatMapData([]);
                        HmViewModel.ResRiskThemeDetails([]);
                        HmViewModel.AggregateBUDetails([]);
                        HmViewModel.InhRiskThemeDetails([]);

                        HmViewModel.editableTypes([]);
                        HmViewModel.CRAAggregateBUInformation([]);

                        HmViewModel.RAT_Config_Type(jsonResult.RAT_Config_Type);

                        // Map Business Units.
                        if (jsonResult.businessUnitsModel.length > 0) {
                            var mappedBusinessUnitData = $.map(jsonResult.businessUnitsModel, function (result) {
                                return new BusinessUnitModel(result);
                            });
                            HmViewModel.ResHeatMapData([]);
                            HmViewModel.ResHeatMapDataDUP([]);
                            HmViewModel.ResHeatMapData(mappedBusinessUnitData);
                            HmViewModel.ResHeatMapDataDUP(mappedBusinessUnitData);

                        }
                       
                        HmViewModel.editableTypes([]);
                        if (jsonResult.ResponseTypesModel.length > 0) {
                            var mappedResponseListData = $.map(jsonResult.ResponseTypesModel, function (result) {
                                return new ResponseColumnsModel(result);
                            });
                            HmViewModel.editableTypes(mappedResponseListData);
                        }
                        HmViewModel.Multilist([]);
                        HmViewModel.Multilist(jsonResult.Multilist);

                        if (HmViewModel.RAT_Config_Type() != 2) {
                            HmViewModel.AMLContMultilist([])
                            HmViewModel.AMLContMultilist(jsonResult.AMLContMultilist);
                        }

                        HmViewModel.ColspanValue([]);
                        HmViewModel.ColspanValue(HmViewModel.editableTypes().length);
                        
                        if (HmViewModel.RAT_Config_Type() == 2) {
                            HmViewModel.CRAAggregateBUInformation([]);
                            if (jsonResult.CRAAggregateBUInformation != null && jsonResult.CRAAggregateBUInformation != undefined) {
                                if (jsonResult.CRAAggregateBUInformation.length > 0)
                                    HmViewModel.CRAAggregateBUInformation(jsonResult.CRAAggregateBUInformation);
                            }

                            if (jsonResult.HeatmapSFGModel != null && jsonResult.HeatmapSFGModel != undefined) {
                                if (jsonResult.HeatmapSFGModel.length > 0) {
                                    HmViewModel.InhRiskThemeDetails(jsonResult.HeatmapSFGModel);
                                    HmViewModel.InhRiskThemeDetailsSearch(jsonResult.HeatmapSFGModel);
                                }
                            }
                        }
                        else { //for aml
                            HmViewModel.AggregateBUDetailsInherent([]);
                            if (jsonResult.InherentAggregateBUInformation != null && jsonResult.InherentAggregateBUInformation != undefined) {
                                if (jsonResult.InherentAggregateBUInformation.length > 0)
                                    HmViewModel.AggregateBUDetailsInherent(jsonResult.InherentAggregateBUInformation);
                            }

                            HmViewModel.AggregateBUDetailsControl([]);
                            if (jsonResult.ControlAggregateBUInformation != null && jsonResult.ControlAggregateBUInformation != undefined) {
                                if (jsonResult.ControlAggregateBUInformation.length > 0)
                                    HmViewModel.AggregateBUDetailsControl(jsonResult.ControlAggregateBUInformation);
                            }

                            HmViewModel.AggregateBUDetailsResidual([]);
                            if (jsonResult.ResidualAggregateBUInformation != null && jsonResult.ResidualAggregateBUInformation != undefined) {
                                if (jsonResult.ResidualAggregateBUInformation.length > 0)
                                    HmViewModel.AggregateBUDetailsResidual(jsonResult.ResidualAggregateBUInformation);
                            }


                            if (jsonResult.AMLInhHeatmapSFGModel != null && jsonResult.AMLInhHeatmapSFGModel != undefined) {
                                if (jsonResult.AMLInhHeatmapSFGModel.length > 0) {
                                    HmViewModel.InhRiskThemeDetails(jsonResult.AMLInhHeatmapSFGModel);
                                }
                            }
                            if (jsonResult.AMLContHeatmapSFGModel != null && jsonResult.AMLContHeatmapSFGModel != undefined) {
                                if (jsonResult.AMLContHeatmapSFGModel.length > 0) {
                                    HmViewModel.ContRiskThemeDetails(jsonResult.AMLContHeatmapSFGModel);
                                }
                            }

                            if (HmViewModel.riskType() === "ALL") {
                                HmViewModel.showControl(false);
                                HmViewModel.Cntstate(false);
                                HmViewModel.Resstate(false);
                                HmViewModel.showResidual(false);
                            }

                        }
                        $('#loadingImgOrCalc').hide();
                    }
                    else {
                        $('#expheatmap').hide();
                        $('#expheatmapHm').hide();
                        $('#error').show();
                        $('#innerdiv').hide();
                    }
                    if (HmViewModel.BUFiltersApplied() == true)
                        $('#f-filter').css('display', '');

                    else
                        $('#f-filter').css('display', 'none');

                    
                    if (HmViewModel.NumberOfBUsSelected() == 0) {
                        $('.badge').css({ 'display': 'none' });
                    }
                    
                }
                catch (e) {
                    var msg = 'Exception: ' + e + ' | Source: ajaxSuccess in getHeatMapData() method in CRAResidualRiskHeatMap.js';
                    logger.logMessage(msg);
                }
            }

            function ajaxFail(error, status) {
                try {

                    if (error.status == 401) {
                        app.showMessage("You have been logged out. Please login again to complete the operation.", "Error in Edit Operation", ["OK"], false, { buttonClass: "fa fa-times btn btn-default", primaryButtonClass: "fa fa-check btn btn-success autofocus", secondaryButtonClass: "", "class": "modal-content messageBox", style: null, popupIcon: 'title-icon col-md-1 fa fa-login' })
                            .then(function (option) {
                                if (option == "OK")
                                    navigation.unauthorized();

                            })
                    }
                    else {
                        var msg = 'Exception: ' + error.statusText + ' | Source: ajaxFail in getHeatMapData() method in CRAResidualRiskHeatMap.js';
                        logger.logMessage(msg);
                    }
                } catch (e) {
                    var msg = 'Exception: ' + e + ' | Source: ajaxFail in getHeatMapData() method in CRAResidualRiskHeatMap.js';
                    logger.logMessage(msg);
                }
            }
        }


        function ResponseColumnsModel(item) {
            try {
                var self = this;
                self.ResponseId = ko.observable(item.ZAT_ID);
                self.ResponseType = ko.observable(item.DISPLAY_NAME);
                self.ShowFlag = ko.observable(true);
                self.colId = ko.observable(item.ZAT_TYPE);
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ResponseColumnsModel() method in ResidualRiskHeatMap.js';
                logger.logMessage(msg);
            }
        }

        function expandInherent() {
            if (HmViewModel.Inhstate() == false) {
                HmViewModel.showInherent(true);
                HmViewModel.Inhstate(true);
                $("#spanInh").addClass("fa-caret-down").removeClass("fa-caret-right");
                if (HmViewModel.Query() != "") {
                    SearchResult();
                }
            }
            else {
                HmViewModel.showInherent(false);
                HmViewModel.Inhstate(false);
                $("#spanInh").addClass("fa-caret-right").removeClass("fa-caret-down");
            }
           
        }
        function expandControl() {
            if (HmViewModel.Cntstate() == false) {
                HmViewModel.showControl(true);
                HmViewModel.Cntstate(true);
                $("#spanCnh").addClass("fa-caret-down").removeClass("fa-caret-right");
                if (HmViewModel.Query() != "") {
                    SearchResult();
                }
            }
            else {
                HmViewModel.showControl(false);
                HmViewModel.Cntstate(false);
                $("#spanCnh").addClass("fa-caret-right").removeClass("fa-caret-down");
            }
            
        }
        function expandResidual() {
            if (HmViewModel.Resstate() == false) {
                HmViewModel.showResidual(true);
                HmViewModel.Resstate(true);
                $("#spanRes").addClass("fa-caret-down").removeClass("fa-caret-right");
            }
            else {
                HmViewModel.showResidual(false);
                HmViewModel.Resstate(false);
                $("#spanRes").addClass("fa-caret-right").removeClass("fa-caret-down");
            }

        }
        //--------------------------------------------------------------------------Logic to Generate the Heat Map Ends----------------------------------------------------

        //--------------------------------------------------------------------------Logic For Exporting Heatmaps to Excel using SSRSS, Expand Collapse functionality starts Here-------------------------------------------------------

        function NavigateToSSRSExportReport() {
            try {
                $('#loadingImgMainHmHm').modal('show');
                var ConcatBUList = "";
                if (HmViewModel.BusinessUnitListForFilters() != undefined && HmViewModel.BusinessUnitListForFilters().length > 0) {
                    for (var i = 0; i < HmViewModel.BusinessUnitListForFilters().length; i++) {
                        if (i == 0)
                            ConcatBUList += HmViewModel.BusinessUnitListForFilters()[i].BusinessUnitId();
                        else {
                            ConcatBUList += "," + HmViewModel.BusinessUnitListForFilters()[i].BusinessUnitId();
                        }
                    }

                }
                var payLoad = {
                    t: appsecurity.getAuthenticationInfo(), AssessmentType: HmViewModel.AssessmentTypeId(), OrgLevel: HmViewModel.ClickedBusinessLevelId(), SourceName: HmViewModel.SourceName(), BUListString: ConcatBUList, RiskType: HmViewModel.riskType()
                };
                utils.postAndRedirect(rootPath + "/FileDownload/ExportHeatmapResults", payLoad, '_blank');
                $('#loadingImgMainHm').modal('hide');
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: NavigateToSSRSExportReport() method in ResidualRiskHeatMap.js';
                logger.logMessage(msg);
            }
        }

        //--------------------------------------------------------------------------Logic For Exporting Heatmaps to Excel using SSRSS ends Here-------------------------------------------------------

        //---------------------------------------------------------------------------Model Definition Starts Here-------------------------------------------------------------------
        function BusinessUnitModel(item) {
            try {
                var self = this;
                self.BU_ID = ko.observable(item.BU_ID);
                self.BU_NAME = ko.observable($('<div/>').html(item.BU_NAME).text());
                self.BusinessUnitId = ko.observable($('<div/>').html(item.BuId).text());
                self.BusinessUnitName = ko.observable($('<div/>').html(item.BuName).text());
                self.Colstate = true;
                self.Colspan = "3";
                var value = item.BU_NAME
                var buVal = "";
                if (item.BU_NAME === undefined) {
                    buVal = item.BuName;
                } else {
                    buVal = item.BU_NAME;
                }
                if (buVal != undefined && buVal.length > 50) {
                    value = buVal.substring(0, 50) + '...';
                } else {
                    var space = buVal.length;
                    var spaceText = '';
                    for (j = 0; j < 5 - space; j++) {
                        spaceText += '&nbsp';
                    }
                    value = spaceText + buVal + spaceText;
                }

                self.BuName = ko.observable($('<div/>').html(value).text());

                self.AssessmentDate = ko.observable($('<div/>').html(item.BuAssessmentDate).text());
                self.BuStatus = ko.observable($('<div/>').html(item.BuStatus).text());
                self.SubLevelId = ko.observable(item.SubLevelId);
                self.isChecked = ko.observable(false);
                if (item.FINAL_Flag != undefined) {
                    HmViewModel.ShowFinalData(item.FINAL_Flag);
                }

            }
            catch (e) {
                var msg = 'Exception' + e + ' | Source: BusinessUnitModel() in InherentHeatMap.js';
                logger.logMessage(msg);
            }
        }

        function BusinessUnitModelFilter(item) {
            try {
                var self = this;
                self.BU_ID = ko.observable(item.BU_ID);
                self.BU_NAME = ko.observable($('<div/>').html(item.BU_NAME).text());
                self.BusinessUnitId = ko.observable($('<div/>').html(item.BuId).text());
                self.BusinessUnitName = ko.observable($('<div/>').html(item.BuName).text());
                self.BuName = ko.observable($('<div/>').html(item.BuName).text());
                self.AssessmentDate = ko.observable($('<div/>').html(item.BuAssessmentDate).text());
                self.BuStatus = ko.observable($('<div/>').html(item.BuStatus).text());
                self.SubLevelId = ko.observable(item.SubLevelId);
                self.isChecked = ko.observable(false);
            }
            catch (e) {
                var msg = 'Exception' + e + ' | Source: BusinessUnitModelFilter() in InherentHeatMap.js';
                logger.logMessage(msg);
            }
        }

        function BusinessLevelModel(item) {
            try {
                var self = this;
                self.BusinessLevelId = ko.observable($('<div/>').html(item.BuLId).text());
                self.BusinessLevelName = ko.observable($('<div/>').html(item.BuLevelName).text());

            } catch (e) {
                var msg = 'exception' + e + ' | Source:BusinessLevelModel() in InherentHeatMap.js';
                logger.logMessage(msg);
            }
        }
        function OverrideCommentModel(item) {
            try {
                var self = this;
                self.CommentId = ko.observable(item.CommentId);
                self.CommentText = ko.observable($('<div/>').html(item.CommentText).text());
                self.UploadedBy = ko.observable($('<div/>').html(item.UploadedBy).text());
                self.UploadRole = ko.observable($('<div/>').html(item.UploadRole).text());
                self.UploadedDate = ko.observable($('<div/>').html(item.UploadedDate).text());
                self.FullName = ko.computed(function () {
                    return item.UploadedBy + " (" + $('<div/>').html(item.UploadRole).text() + ")";
                });
            }
            catch (e) {
                var msg = 'exception' + e + ' | Source: OverrideCommentModel() in InherentHeatMap.js';
                logger.logMessage(msg);
            }
        }
        function AggregateBUInformationModel(item) {
            var self = this;
            self.BU_ID = ko.observable(item.BU_ID);
            self.BU_NAME = ko.observable(item.BU_NAME);
            self.CALC_ID = ko.observable(item.CALC_ID);
            self.CALC_CSS = ko.observable(item.CALC_CSS);
            var trimmedCALC_Level = item.CALC_LEVEL;
            if (trimmedCALC_Level.length > 21)
                trimmedCALC_Level = trimmedCALC_Level.substring(0, 18) + '...';
            else
                trimmedCALC_Level = trimmedCALC_Level;

            self.CALC_LEVEL_TEXT = ko.observable(trimmedCALC_Level);
            self.CALC_LEVEL_ToolTip = ko.observable(item.CALC_LEVEL);
            self.CALC_LEVEL = ko.observable(item.CALC_LEVEL);
            self.COMPLIANCE_ID = ko.observable(item.COMPLIANCE_ID);
            var CompLevel = item.COMPLIANCE_LEVEL;
            if (CompLevel.length > 21)
                CompLevel = CompLevel.substring(0, 18) + '...';
            else
                CompLevel = CompLevel;

            self.COMPLIANCE_LEVEL_TEXT = ko.observable(CompLevel);
            self.COMPLIANCE_LEVEL_ToolTip = ko.observable(item.COMPLIANCE_LEVEL);
            self.COMPLIANCE_LEVEL = ko.observable(item.COMPLIANCE_LEVEL);
            self.COMPLIANCE_CSS = ko.observable(item.COMPLIANCE_CSS);
            self.FINAL_ID = ko.observable(item.FINAL_ID);
            var trimmedLevel = item.FINAL_LEVEL;
            if (trimmedLevel.length > 21)
                trimmedLevel = trimmedLevel.substring(0, 18) + '...';
            else
                trimmedLevel = trimmedLevel;

            self.FINAL_LEVEL_TEXT = ko.observable(trimmedLevel);
            self.FINAL_LEVEL_ToolTip = ko.observable(item.FINAL_LEVEL);
            self.FINAL_LEVEL = ko.observable(item.FINAL_LEVEL);
            self.FINAL_CSS = ko.observable(item.FINAL_CSS);
            self.RISK_CSS = ko.observable(item.RISK_CSS);
            self.RISK_SCORE = ko.observable(item.RISK_SCORE);
            self.OLD_SELECTED_DROPDOWN = ko.observable();
            self.SELECTED_DROPDOWN = ko.observable();
            self.OverrideCommentsList = ko.observable();
            self.ClickShowComments = function () {
                var ParamString = "BusinessUnitId=" + self.BU_ID() + "&RiskAreaId=0&RiskFactorId=0&TableType=INH&AssessmentType=" + HmViewModel.AssessmentType() + "&HeatMapType=INH&CommentType=B&ValueType=null&OrganizationalLevelID=" + HmViewModel.ClickedBusinessLevelId() + "&AssessmentTypeId=" + HmViewModel.AssessmentTypeId();
                $.ajax({
                    url: "/api/HeatMap/GetOverrideComment?" + ParamString,
                    type: "GET",
                    headers: appsecurity.getSecurityHeaders()
                })
                    .success(function (jsonResult, success) {
                        try {
                            if (jsonResult != null) {
                                var mappedOverrideCommentsList = $.map(jsonResult, function (result) {
                                    return new OverrideCommentModel(result);
                                });
                                HmViewModel.OverrideCommentsList([]);
                                HmViewModel.OverrideCommentsList(mappedOverrideCommentsList);
                                $('#ViewOverrideCommentsPopUp').modal('show');
                            }
                            else
                                logger.logError('Failed to load  Override comments. Please try again.', 'Error', system.getModuleId(HmViewModel), true);
                        }
                        catch (e) {
                            var msg = 'Exception: ' + e + ' | Source: ajaxSuccess call in GetOverrideComments() method in CRAResidualRiskHeatMap.js';
                            logger.logMessage(msg);
                        }
                    })
                    .fail(function (fail, error) {
                        logger.logError('Failed to load  Override comments. Please try again.', 'Error', system.getModuleId(HmViewModel), true);
                    });

            };
        }

        function ClickShowComments(data) {
            var ParamString = "BusinessUnitId=" + data.BU_ID() + "&RiskAreaId=0&RiskFactorId=0&TableType=INH&AssessmentType=" + HmViewModel.AssessmentType() + "&HeatMapType=INH&CommentType=B&ValueType=null&OrganizationalLevelID=" + HmViewModel.ClickedBusinessLevelId() + "&AssessmentTypeId=" + HmViewModel.AssessmentTypeId();
            $.ajax({
                url: "/api/HeatMap/GetOverrideComment?" + ParamString,
                type: "GET",
                headers: appsecurity.getSecurityHeaders()
            })
                .success(function (jsonResult, success) {
                    try {
                        if (jsonResult != null) {
                            var mappedOverrideCommentsList = $.map(jsonResult, function (result) {
                                return new OverrideCommentModel(result);
                            });
                            HmViewModel.OverrideCommentsList([]);
                            HmViewModel.OverrideCommentsList(mappedOverrideCommentsList);
                            $('#ViewOverrideCommentsPopUp').modal('show');
                        }
                        else
                            logger.logError('Failed to load  Override comments. Please try again.', 'Error', system.getModuleId(HmViewModel), true);
                    }
                    catch (e) {
                        var msg = 'Exception: ' + e + ' | Source: ajaxSuccess call in GetOverrideComments() method in CRAResidualRiskHeatMap.js';
                        logger.logMessage(msg);
                    }
                })
                .fail(function (fail, error) {
                    logger.logError('Failed to load  Override comments. Please try again.', 'Error', system.getModuleId(HmViewModel), true);
                });

        }
        
        function DisplayExportDropdown(data, event) {
            closeSideNav();
            $('#myValueDropdownLevel').removeClass('show');
            $('#myValueDropdownSortLevel').removeClass('open');

            document.getElementById("exportDropdown").classList.toggle("show");
            document.getElementById("exportDropdownBtn").classList.toggle("open");

        }

        function FormatValueDataLevel(data, event) {
            $('#myValueDropdown').removeClass('show');
            $('#myValueDropdownSort').removeClass('open');
            $('#myDropdown').removeClass('show');
            $('#myDropdownSort').removeClass('open');
            $('#exportDropdown').removeClass('show');
            $('#exportDropdownBtn').removeClass('open');

            document.getElementById("myValueDropdownLevel").classList.toggle("show");
            document.getElementById("myValueDropdownSortLevel").classList.toggle("open");
        }

        function valuechangeLevel(data, event) {
            try {
                var optionId = event.currentTarget.id;
                if (event.currentTarget.firstElementChild.style.display === "none") {
                    event.currentTarget.firstElementChild.style.display = "inline-block"
                }
                else {
                    event.currentTarget.firstElementChild.style.display = "none";
                }
                
                getHeatMapData();
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: valuechangeLevel() method in Activity.js';
                logger.logMessage(msg);
            }
        }

        //---------------------------------------------------------------------------Model Definition Ends Here---------------------------------------------------------------------//

        function ClearResult() {
            try {
                if (HmViewModel.Query() != "") {
                    $(".reset-search").show();
                    return false;
                }
                else {
                    $(".reset-search").hide();
                    ResetSearch();
                }

            } catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ClearResult() method in SurveyResponsePage.js';
                logger.logMessage(msg);
            }
        }

        function ResidualFilter(data, event) {
            $('#filter li a').removeClass("active");
            $('#FilterRes').addClass("active");
            HmViewModel.riskType('R');
            $('#expandA').hide();
            $('#collapseA').show();
            getHeatMapData();
        }

        function ControlFilter(data, event) {
            $('#filter li a').removeClass("active");
            $('#FilterCnt').addClass("active");
            HmViewModel.riskType('C');
            $('#expandA').hide();
            $('#collapseA').show();
            getHeatMapData();
        }

        function InherentFilter(data, event) {
            $('#filter li a').removeClass("active");
            $('#FilterInh').addClass("active");
            HmViewModel.riskType('I');
            $('#expandA').hide();
            $('#collapseA').show();
            getHeatMapData();
        }

        function FilterALL(data, event) {
            $('#filter li a').removeClass("active");
            $('#FilterAll').addClass("active");
            HmViewModel.riskType('ALL');
            $("#spanCnh").addClass("fa-caret-right").removeClass("fa-caret-down");
            $("#spanRes").addClass("fa-caret-right").removeClass("fa-caret-down");
            getHeatMapData();
        }

    });

